import { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { Grid, Box, Typography, Divider } from '@mui/material';
import FieldView from 'core/components/layout/FieldView';
import MfproductInfo from '../MfproductInfo';
import FieldView2 from 'core/components/layout/FieldView2';
import IconEnabled from 'core/components/layout/IconEnabled';


export default function MfproductListTableRow({ obj, getActionComponent, actionList, handleRowClick }) {
  useEffect(() => {
  }, [])
  return (

    <>
      <Grid container direction="row" sx={{ width: '100%', backgroundColor: 'white', borderRadius: 3 }}>
        <Grid item  xl={4} lg={4} sm={4} xs={12} sx={{ height: '100%', padding: 1, }}>

          <Grid container display="flex" direction="column" justifyContent="center" alignItems="center">
            <Grid item lg={12} sm={12} xs={12} sx={{ backgroundColor: 'secondary.200', borderRadius: '5px', height: '100%' }}>
              <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <img
                  src={obj.imageurl}
                  alt={obj.imageurl === '' ? "Not Found" : obj.title}
                  style={{ width: '100%', height: '100%', borderRadius: '5px', }}
                />
              </div>
            </Grid>
          </Grid>
        </Grid>

        <Grid item xl={8} lg={8} sm={8} xs={12} sx={{ width: '100%', padding: 1, }}>
          <Grid container direction="row"
            sx={{
              cursor: 'pointer',
              justifyContent: "flex-start", alignItems: "center", backgroundColor: obj.expand ? 'primary.200' : 'white',
              '&:hover': {
                backgroundColor: 'secondary.lighter', color: 'primary.main'
              },
            }}>
            <Grid item xl={6} lg={6} sm={9} xs={6} ><FieldView2 label="Title" value={obj.title} /></Grid>
            <Grid item xl={6} lg={3} sm={3} xs={6} ><FieldView2 label="Code" value={obj.code} /></Grid>
            <Grid item xl={6} lg={3} sm={3} xs={6} ><FieldView2 label="Price" value={obj.price} /></Grid>
            {/* <Grid item xl={6} lg={3} sm={6} xs={6} ><FieldView2 label="Inventory" value={obj.stockcount} /></Grid> */}
            <Grid item xl={12} lg={12} sm={12} xs={12}>
              <Grid item xl={12} xs={12} sm={12} md={12} lg={12} sx={{ padding: 0.5, borderRadius: 3, wordBreak: 'break-word', overflowWrap: 'break-word', textAlign: 'left' }}>
                <Typography color="textSecondary" variant="h6" sx={{ fontSize: 14 }}>
                  Description
                </Typography>
                <Typography
                  sx={{ color: 'primary.darker', fontWeight: 'light', fontSize: 15 }}
                  component="div" // Use div to allow HTML rendering
                >
                  {obj.description.replace(/&#34;/g, '"').split('\n').map((line, index) => (
                    <span key={index}>
                      {line}
                      <br />
                    </span>
                  ))}
                </Typography>
              </Grid>
            </Grid>

            <Grid container direction="row" sx={{ justifyContent: "flex-end", width: '100%', }}>
                <IconEnabled key={`${obj.id}-${actionList[3].title}`} actionObj={actionList[3]} id={obj.id} />
                <IconEnabled key={`${obj.id}-${actionList[5].title}`} actionObj={actionList[5]} id={obj.id} />
                <IconEnabled key={`${obj.id}-${actionList[6].title}`} actionObj={actionList[6]} id={obj.id} />
                {/* <IconEnabled key={`${obj.id}-${actionList[7].title}`} actionObj={actionList[7]} id={obj.id} /> */}
                
            </Grid>


            {/* <Grid item lg={2} xs={3} ><Typography color="" sx={{ fontWeight: 'light', fontSize: 15 }}>{obj.title}</Typography></Grid>
            <Grid item lg={2} xs={3} ><Typography color="" sx={{ fontWeight: 'light', fontSize: 15 }}>{obj.code}</Typography></Grid>
            <Grid item lg={2} xs={3} ><Typography color="" sx={{ fontWeight: 'light', fontSize: 15 }}>{obj.description.replace(/&#34;/g, '"')}</Typography></Grid>
            <Grid item lg={2} xs={3} ><Typography color="" sx={{ fontWeight: 'light', fontSize: 15 }}>{obj.stockcount}</Typography></Grid>
            <Grid item lg={4} xs={4} >
              <Grid container direction="row" sx={{ justifyContent: "flex-end", width: '100%', }}>
                {getActionComponent(obj)}
              </Grid>
            </Grid> */}

          </Grid>
        </Grid>
        <Grid item xl={12} lg={12} sx={{ width: '100%' }}></Grid>
        {obj.expand ?
          <Grid container direction="row">
            <Grid item sx={{ width: '100%' }}>
              < MfproductInfo mfproductObj={obj} />
            </Grid>
            <Grid item sx={{ width: '100%' }}>
              <Divider />
            </Grid>
          </Grid>
          : <Grid container direction="row">
            <Grid item sx={{ width: '100%' }}>
              <Divider />
            </Grid>
          </Grid>}
      </Grid>
    </>

  )
}